import { ApiRoutes } from '@/services/ApiRoutes.js';
import { BackendAPI } from '@/services/BackendAPI.js';

export default {
  all() {
    return BackendAPI('get', ApiRoutes.schoolYear.all());
  },
};
